import React from 'react';
import * as ThemeUI from 'theme-ui';

export const Container = ({ children, ...props }) => (
  <ThemeUI.Container {...props}>
    {children}
  </ThemeUI.Container>
);
